// Thesis URL builders. Two URLs:
//
//   1. **Share URL** — `/thesis/<signature>`. Short, OG-friendly. The
//      `app/[locale]/thesis/[signature]/page.tsx` route owns this URL,
//      emits OG metadata for crawlers, and bounces the user to the
//      canonical market URL on the client.
//   2. **Canonical URL** — `/markets/<marketPubkey>?tab=debate&thesis=<sig>`.
//      The actual page where the thesis is rendered. The market page
//      reads `?tab=debate&thesis=<sig>` and scrolls to the thesis card.
//
// Keep both helpers in lockstep — when one changes, fix the other.

const THESIS_SHARE_PATH_PREFIX = '/thesis';
const MARKETS_PATH_PREFIX = '/markets';

/** Relative share-link path. Prefer this over hand-rolled template
 *  literals so the prefix lives in one place. */
export function buildThesisShareUrl(signature: string): string {
  return `${THESIS_SHARE_PATH_PREFIX}/${signature}`;
}

/** Relative canonical path the share page redirects to. The market
 *  page reads `tab` + `thesis` from `searchParams` and scrolls to the
 *  matching thesis card on mount. */
export function buildThesisCanonicalUrl(marketPubkey: string, signature: string): string {
  const qs = new URLSearchParams({ tab: 'debate', thesis: signature });
  return `${MARKETS_PATH_PREFIX}/${marketPubkey}?${qs.toString()}`;
}
